module.exports = __webpack_public_path__ + "static/media/bg_06.b4b95a19.png";